import gql from 'graphql-tag';

export default gql`
  query microsoftPreviewURL(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    microsoftPreviewURL(
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;
